module.exports = __webpack_public_path__ + "img/md-time.054e025f.svg";